import './MobileSearch.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {GetSearch,IsOpen,GetBlogCount} from "../../redux/actions";
import {connect} from "react-redux";
import {InputGroup} from "../uiElements/inputGroup/InputGroup";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import moment from "moment";
import {CloseMenuIcon, NewsArrIcon, SearchCloseIcon, SearchGrayIcon} from "../../assets/images";
import React, {useState,useEffect} from "react";
import {useDebounce} from "use-debounce";
import {Link, useHistory, useLocation} from "react-router-dom";

function MobileSearch(props){
    const {search,className,mobileSearchOpen,toggleSearchMenu,staticTexts,toggleMobileMenu} = props
    const [closeSearch, setCloseSearch] = useState(false)
    const [mounted, setMounted] = useState(false)
    const [state, setState] = useState('')
    const [value] = useDebounce(state, 1000);
    const history = useHistory()
    const location = useLocation()
    const data = value.split('')

    useEffect(()=>{
        setMounted(true)
    }, [])
    useEffect(() => {
        props.IsOpen(mobileSearchOpen)
    },[mobileSearchOpen])

    function getInputValues (e) {
        const { name, value } = e.target
        // if (name === "text" && value && !/^\S/.test(value)) {
        //     return
        // }
        setState(value)
    }
    function searchByText(){
        history.push("/search");
        toggleSearchMenu()
    }

    useEffect(() => {
        window.addEventListener('click' ,() => setCloseSearch(false));
    },[])

    useEffect(() => {
        if(mounted){
            if(data?.length > 2 || data?.length === 0){
                props.GetBlogCount({text:value})
                props.GetSearch({text:value}).finally(() => {
                    if(search?.length && data?.length > 2 ){
                        setCloseSearch(true)
                    }
                })
            }
        }
    },[value])

    useEffect(() => {
        if(location.pathname !== '/search'){
            setState('')
        }
    },[location.pathname])

    return <div className={`mobileSearch-wrapper ${className}`}>
        <div className={'mobile_search'}>
            <div className={'mobile_search_content'}>
                <div className="search_btn" onClick={searchByText}>
                    <SearchGrayIcon/>
                </div>
                <InputGroup inputType={'input'}
                            type={"text"}
                            value={state}
                            name={'state'}
                            maxLength={100}
                            onKeyDown={(e) => {
                                e.key === 'Enter' && searchByText()
                            }}
                            placeholder={staticTexts?.header_search_placeholder}
                            className="search_input"
                            onChange={getInputValues}>
                </InputGroup>
            </div>
            <div className={'mobileSearch-close'} onClick={toggleSearchMenu}>
                <SearchCloseIcon/>
            </div>
        </div>

        {
            closeSearch ? <div className={'search-result-wrapper'}>
                 {
                     search?.length ? <div className={'search-result'}>
                         {
                             search?.map(item => {
                                 return <Link to={`/news/${item?.slug}`} className={'search-result-card'} onClick={toggleSearchMenu}>
                                     <div className={'search-result-img-wrapper'}>
                                         <div className={'search-result-img'}>
                                             <img src={generateFileMediaUrl(item?.mediaMain?.path)} alt=""/>
                                         </div>
                                     </div>
                                     <div className={'search-result-info'}>
                                         <div className={'search-result-date'}>
                                             {moment(item?.date).format('ll')}
                                         </div>
                                         <div className={'search-result-title'}>
                                             <span>{item?.title}</span> <NewsArrIcon/>
                                         </div>
                                     </div>
                                 </Link>
                             })
                         }
                     </div> : <div className={'search-noResult'}>
                         {staticTexts?.header_search_notResult}
                     </div>
                 }
            </div>  : ''
        }
    </div>

}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'search',
        'languages',
        'selectedLanguage',
    ])
};
const mapDispatchToProps = {
    GetSearch,
    IsOpen,
    GetBlogCount
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileSearch);